import { ActionIcon, Box, Group, Menu } from '@mantine/core';
import { GroupColorInputProps } from './types';
import { palette } from '@app/shared/ui-kit/colors';
import { useGroupColors } from '../hooks/useGroupColors';
import { useState } from 'react';

export function ColorBox({
  color,
  size = 20,
  onClick,
}: {
  color: string | undefined;
  size?: number | string;
  onClick?: () => void;
}) {
  return (
    <ActionIcon onClick={onClick} variant="transparent" size="sm">
      <Box
        w={size}
        h={size}
        style={{
          backgroundColor: color ?? palette.blackroomGray,
          borderRadius: '100%',
        }}
      />
    </ActionIcon>
  );
}

export default function GroupColorInput({
  color,
  onChange,
}: GroupColorInputProps) {
  const groupColors = useGroupColors();
  const [opened, setOpened] = useState(false);

  return (
    <Menu
      position="bottom-end"
      offset={{ crossAxis: 10 }}
      closeOnItemClick
      opened={opened}
    >
      <Menu.Target>
        <Box>
          <ColorBox
            color={color}
            onClick={() => setOpened(!opened)}
            size={20}
          />
        </Box>
      </Menu.Target>

      <Menu.Dropdown>
        <Group gap={5} p={5}>
          {groupColors.map((groupColor) => (
            <ColorBox
              key={groupColor}
              color={groupColor}
              onClick={() => {
                setOpened(false);
                onChange?.(groupColor);
              }}
            />
          ))}
        </Group>
      </Menu.Dropdown>
    </Menu>
  );
}
